

var initialState =
{
    isSaving: false,
    notConnected: false
}



const planService = (state = initialState, action) => {
    switch (action.type) {  
        case 'PLAN_SAVED':
        return Object.assign({}, state, {
            isSaving:false
       })
       case 'START_PLAN_SAVING':
       return Object.assign({}, state, {
           isSaving: true,
           notConnected: false
       })
        case 'SAVE_FAILED':
            return Object.assign({}, state, {
                notConnected: true,
                isSaving: false
            })

     default:
      return state;
  }
}
export default planService